import { Animation, AnimationClip, AnimationState, _decorator } from 'cc';
import Page from './Page';

const { ccclass, requireComponent } = _decorator;

@ccclass('AnimatedPage')
@requireComponent(Animation)
export default class AnimatedPage extends Page {
    private _animation: Animation = null;
    private _openAnimation: AnimationClip = null;
    private _closeAnimation: AnimationClip = null;

    public onLoad() {
        super.onLoad();
        this._animation = this.getComponent(Animation);
        if (this._animation) {
            this._openAnimation = this._animation.clips.find((clip) => clip.name.includes('Open'));
            this._closeAnimation = this._animation.clips.find((clip) => clip.name.includes('Close'));
        }
    }

    protected async playOpen(playTransition: boolean): Promise<void> {
        if (!this._animation) {
            return;
        }
        this._animation.stop();
        const animationState = this._animation.getState(this._openAnimation.name);
        animationState.wrapMode = AnimationClip.WrapMode.Normal;
        this._animation.play(animationState.name);
        if (playTransition) {
            await this._animation.waitForFinished(this._openAnimation.name);
        } else {
            animationState.setTime(Number.MAX_SAFE_INTEGER);
        }
    }

    protected async playClose(playTransition: boolean): Promise<void> {
        if (!this._animation) {
            return;
        }
        this._animation.stop();
        let animationState: AnimationState;
        if (this._closeAnimation) {
            animationState = this._animation.getState(this._closeAnimation.name);
        } else {
            animationState = this._animation.getState(this._openAnimation.name);
            animationState.wrapMode = AnimationClip.WrapMode.Reverse;
        }
        this._animation.play(animationState.name);
        if (playTransition) {
            await this._animation.waitForFinished(animationState.name);
        } else {
            animationState.setTime(Number.MAX_SAFE_INTEGER);
        }
    }
}
